<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="flex w-100 flex-col gap-6">
      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.file" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie dla wersji mobilnej">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.smallFile" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <div class="flex flex-col gap-4">
        <app-form-control
          hint="Przykład: https://domain.com"
          label="Adres URL">
          <input
            [formControl]="form.controls.url"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź adres URL" />
        </app-form-control>

        <app-form-control label="Status">
          <p-select
            [fluid]="true"
            [formControl]="form.controls.status"
            [options]="valueOrDefault(statusSelectItems$ | async, [])"
            appPrimengSelect
            placeholder="Wybierz status" />
        </app-form-control>

        <app-form-control label="Data rozpoczęcia wyświetlania">
          <p-date-picker
            [formControl]="form.controls.visibilityStartDate"
            [showIcon]="true"
            [showTime]="true"
            appendTo="body"
            placeholder="Wybierz datę rozpoczęcia" />
        </app-form-control>

        <app-form-control label="Data zakończenia wyświetlania">
          <p-date-picker
            [formControl]="form.controls.visibilityEndDate"
            [showIcon]="true"
            [showTime]="true"
            appendTo="body"
            placeholder="Wybierz datę zakończenia" />
        </app-form-control>
      </div>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
